export default __webpack_public_path__ + "static/media/icon-arrow-page-left.8bb7d969.svg";